import React from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { withTheme } from '@material-ui/core/styles';
import { getFormat, twoDigits, makeGraph } from 'lib/commonLib';
import { appStatusGraphData } from 'lib/api/datacenter';
import { paramConverter } from 'modules/common';

import CurrentStatus from 'components/atoms/CurrentStatus';
import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

const graphList = [
  {
    title: i18next.t('신규 ADID'),
    data: { bar: ['NEW_ADID'] },
    yAxisData: {
      left: { NEW_ADID: true },
      right: {},
    },
  },
];

class AppStatusGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      infoMessage: '',
      loading: false,
      error: false,
      noData: false,
    };
  }

  getData = () => {
    const { params, locale, t } = this.props;
    const { sDate, eDate } = params;
    const format = getFormat(locale);

    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });

    appStatusGraphData({ ...paramConverter(params) })
      .then((response) => {
        const { data } = response.data;
        if (data.length === 0) {
          this.setState({
            ...this.state,
            noData: true,
            loading: false,
          });
        } else if (typeof data !== 'undefined') {
          this.setState({
            ...this.state,
            primitiveData: data,
            loading: false,
            noData: false,
            error: false,
          });

          this.handleChangeGraph(graphList[0], 0)();
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
          noData: false,
        });
      });
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    const { t, theme } = this.props;
    const dateObj = moment(originalDate, 'YYYYMMDD');
    const month = twoDigits(dateObj.month() + 1);
    const date = dateObj.date();
    const day = dateObj.day();
    let color = '';

    if (day === 0) {
      color = theme.palette.common.red;
    } else if (day === 6) {
      color = theme.palette.common.blue;
    }

    return onlyDay ? (
      `${twoDigits(date)}${t('일')}`
    ) : (
      <span style={{ color }}>{`${t(month + '월')} ${twoDigits(date)}${t(
        '일'
      )}`}</span>
    );
  };

  xAxisTick = (tickProps) => {
    const { theme } = this.props;
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dateObj = moment(value, 'YYYYMMDD');
    const day = dateObj.day();

    const dayStr = this.makeLabel(true)(value);
    let fill = '';
    //Sunday as 0 and Saturday as 6.
    if (day === 0) {
      fill = theme.palette.common.red;
    } else if (day === 6) {
      fill = theme.palette.common.blue;
    }

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={-5} dy={16} fill={fill} textAnchor="middle">
          {dayStr}
        </text>
      </g>
    );
  };

  /**
   * 버튼 클릭하여 그래프 데이터 변경
   */
  handleChangeGraph =
    (
      { title, data, yAxisData, customizeData: customize, isPercent = false },
      index
    ) =>
    (e) => {
      const { primitiveData } = this.state;

      if (typeof data !== 'undefined') {
        const { graphData, dataKeys, customizeData, keyLabel, stackId } =
          makeGraph({ data, customize, primitiveData });

        const result = (
          <MultiplexChart
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={stackId.length !== 0 ? stackId.join('$') : null}
            yAxisData={yAxisData}
            legend
            title={title}
            isPercent={isPercent}
          />
        );

        this.setState({
          ...this.state,
          curGraphComponent: result,
          selectedIdx: index,
        });
      }
    };

  render() {
    const { handleRefesh } = this;
    const { t } = this.props;
    const { infoMessage, curGraphComponent, loading, error, noData } =
      this.state;

    return (
      <SwitchingArea
        title={
          <>
            <InfoTitleArea
              title={t('신규 ADID')}
              tooltipTitle={infoMessage}
              iconType="fainfoCircle"
              iconColor="graph"
            />
          </>
        }
        handleRefesh={handleRefesh}
      >
        {loading || noData || error ? (
          <CurrentStatus
            type={loading ? 'loading' : noData ? 'noData' : error && 'error'}
          />
        ) : (
          <ContentsWrap contentsCount={1}>{curGraphComponent}</ContentsWrap>
        )}
      </SwitchingArea>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withTheme(AppStatusGraph))
  )
);
